export default __webpack_public_path__ + "static/media/faq.9ade8515.jpg";